import React from "react";

const AboutMe = () => {
  const date = new Date().getFullYear();

  return (
    <section className="about-me">
      <div className="container">
        <div className="about-me__content">
          <h1>Hi, I'm Enes. Nice to meet you.</h1>
          <p>
            I completed Bachelor's Degree in Computer Science at Canakkale
            Onsekiz Mart University in March 2021. I have been developing myself
            in the front-end for {date - 2019} years. I'm quite confident in
            coding designs to be responsive applications and web pages. I think
            in a way I'm kind of like those web pages; I'm modable, but i still
            keep my creative flare intact.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
